import React from "react";
import "./BannerNewPortal.scss";
import { Info, Close } from "@/icons";
import { Link as ILink } from "@anoki/fse-common/dist";
import { Link } from "@/components";

export type BannerNewPortalProps = {
  title: string;
  subtitle: string;
  link: ILink;
  onClose?: () => void;
};

export const BannerNewPortal: React.FC<BannerNewPortalProps> = ({
  title,
  subtitle,
  link,
  onClose,
}) => {
  return (
    <blockquote className={`styled-banner`}>
      {onClose && (
        <div className="close-icon" onClick={onClose}>
          <Close width={32} height={32} />
        </div>
      )}
      <div className="container">
        <Info color="primary" width={32} height={32} />
        <div className="right-container">
          <h1 className="title">{title}</h1>
          <p className="subtitle">{subtitle}</p>
          <Link title={link.title} src={link.link} />
        </div>
      </div>
    </blockquote>
  );
};
